import Instance from '../../../../utils/Axios';

const EnviarValidacaoCD = (ydata, setValidarBtn) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .post('/obras/validacao/chefedepartamento', { ydata })
      .then(({ data }) => {
        console.log(data);
        setValidarBtn(true);
        if (stateToken) {
          dispatch({ type: 'POST_VALIDACAO_INDIVIDUAL_CD', payload: data });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default EnviarValidacaoCD;
